import { usePostRedirect } from './usePostRedirect';
import { useApiErrorHandler } from './useApiErrorHandler';
import { useCallback } from 'react';
import { apiAuth } from '../resources/api/apiAuth';

const { useZendeskSso } = apiAuth;

/**
 * Zendesk SSO flow:
 * 1. user goes to support.pixotope.com and clicks "sign in"
 * 2. user is taken to following address:
 *    https://prod.pixotope.cloud/start?brand_id=360000205078&locale_id=1&return_to=https%3A%2F%2Fsupport.pixotope.com%2Fhc%2Fen-us&timestamp=1740401973
 * 3. user needs to select an account that is currently logged in, or they need to sign in
 * 4. ui app obtains a zendesk token from cloud api
 * 5. ui app performs a POST redirect with jwt in a body
 *
 * Following function's responsibility is to handle step 4 and 5.
 */
export const useZendeskRedirect = () => {
  const postRedirect = usePostRedirect();
  const { execute: zenDeskSSO } = useZendeskSso();
  const handleApiError = useApiErrorHandler();

  return useCallback(
    async (return_to: string, target?: string) => {
      if (!return_to) {
        return null;
      }
      try {
        const response = await zenDeskSSO();

        const search = new URLSearchParams();
        search.set('return_to', return_to);
        const endpoint = `https://pixotope.zendesk.com/access/jwt?${search}`;
        const body = {
          jwt: response.payload.token,
        };

        postRedirect(endpoint, body, target);
        return;
      } catch (e) {
        handleApiError(e);
      }
    },
    [zenDeskSSO]
  );
};
